<template>
  <div class="services-sidebar-section" v-if="!numbersSelected">
    <div class="services-sidebar-section__head">
      <label>
        <span>2</span>
        <input
            v-model="searchDomains"
            :placeholder="getLocalization('Find domain')"
        />
        <img src="/img/svg/common/search-black.svg"/>
      </label>
      <button class="button primary" @click="isOpenFilter = !isOpenFilter">
        {{ getLocalization('Sort by') }}
      </button>
    </div>

    <SortFilterPanel
        v-if="isOpenFilter"
        :activeFilter="activeFilter"
        :sortOptions="{
        price: sortByPriceOption,
        quantity: sortByQuantityOption
      }"
        @sort-by-price="handleSortByPrice"
        @sort-by-quantity="handleSortByQuantity"
    />

    <div
        v-if="filteredAndSortedDomains.length > 0 || isMounted"
        class="services-sidebar-section__body services-sidebar__countries --more"
    >
      <div
          class="services-sidebar-country"
          v-if="filteredAndSortedDomains.length < 1"
      >
        <div class="services-sidebar-country__item">
          <div class="--name">{{ getLocalization('No mail available yet') }}</div>
        </div>
      </div>

      <MailDomainItem
          v-for="(mail, index) in filteredAndSortedDomains"
          :key="index"
          :mail="mail"
          :individual-prices=individualPrices
          @buy-mail="$emit('buy-mail', ...arguments)"
      />
    </div>

    <div v-else class="services-sidebar-section__body services-sidebar__countries --more">
      <SkeletonLoader v-for="(_, index) in rowsCountry" :key="index" type="mail"/>
    </div>

    <div class="services-sidebar-section__footer"></div>
  </div>
</template>

<script>
import SortFilterPanel from './sortFilterPanel.vue';
import MailDomainItem from './mailDomainItem.vue';
import SkeletonLoader from './skeletonLoader.vue';

export default {
  components: {
    SortFilterPanel,
    MailDomainItem,
    SkeletonLoader
  },
  props: {
    numbersSelected: Boolean,
    mailDomains: Array,
    isMounted: Boolean,
    rowsCountry: [Array, Number],
    individualPrices: Object,
  },
  data() {
    return {
      searchDomains: '',
      isOpenFilter: false,
      activeFilter: 1, // По умолчанию сортировка по цене
      sortByPriceOption: 0, // 0 - top, 1 - bottom
      sortByQuantityOption: 0,
      currentSort: {
        type: 'default',
        direction: 'top'
      }
    };
  },
  computed: {
    filteredDomains() {
      if (!this.mailDomains) return [];

      const searchTerm = this.searchDomains.toLowerCase().trim();
      if (!searchTerm) return this.mailDomains;

      return this.mailDomains.filter(mail => {
        const domainName = mail.domain?.front_name?.toLowerCase() || '';
        return domainName.includes(searchTerm);
      });
    },
    filteredAndSortedDomains() {
      return this.sortDomains([...this.filteredDomains]);
    }
  },
  methods: {
    getLocalization(key) {
      return this.$root.getLocalization
          ? this.$root.getLocalization(key)
          : key;
    },
    sortDomains(domains) {
      return domains.sort((a, b) => {
        switch (this.currentSort.type) {
          case 'price':
            return this.currentSort.direction === 'top'
                ? a.price - b.price
                : b.price - a.price;
          case 'quantity':
            return this.currentSort.direction === 'top'
                ? a.count - b.count
                : b.count - a.count;
          default:
            return 0;
        }
      });
    },
    handleSortByPrice() {
      this.activeFilter = 1;
      this.sortByPriceOption = this.sortByPriceOption === 0 ? 1 : 0;
      this.currentSort = {
        type: 'price',
        direction: this.sortByPriceOption === 0 ? 'top' : 'bottom'
      };
    },
    handleSortByQuantity() {
      this.activeFilter = 2;
      this.sortByQuantityOption = this.sortByQuantityOption === 0 ? 1 : 0;
      this.currentSort = {
        type: 'quantity',
        direction: this.sortByQuantityOption === 0 ? 'top' : 'bottom'
      };
    }
  }
}
</script>